import 'firebase/auth';
import axios from '@/axios';
import jwt from '../../http/requests/auth/jwt/index.js';

export default {
  fetchOrganizations(_context, data) {
    return new Promise((resolve, reject) => {
      let fetchOrganizationUrl =
        '/api/v1/organization/list?page=' +
        data.page +
        '&limit=' +
        data.limit +
        '&search=' +
        data.search +
        '&sort=' +
        data.sort +
        '&dir=' +
        data.dir +
        '&filter=' +
        data.filter;

      axios
        .get(fetchOrganizationUrl)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchAssociatedOrganizations(_context, data) {
    return new Promise((resolve, reject) => {
      let fetchOrganizationUrl =
        '/api/v1/organizations/' +
        data.id +
        '?page=' +
        data.page +
        '&limit=' +
        data.limit +
        '&search=' +
        data.search +
        '&sort=' +
        data.sort;

      axios
        .get(fetchOrganizationUrl)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchOrganizationDetails(_context, id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/v1/organization/${id}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchOrganizationUserRoles(_context, { organizationId, userId }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/v1/organization/${organizationId}/user/role/${userId}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchOrganizationAllClinics(_context, id) {
    let path = '/api/v1/organization/' + id + '/clinics/list';
    return new Promise((resolve, reject) => {
      axios
        .get(path)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchOrganizationClinicsV2(_context, id) {
    let path = '/api/v1/organization/' + id + '/clinics/list/v2';
    return new Promise((resolve, reject) => {
      axios
        .get(path)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchAsociatedOrganizationAllClinics(_context, data) {
    let path = '/api/v1/organization/' + data.id + '/clinics/list/'+ data.role+`${data.userId?'?userId='+data.userId:''}`;
    return new Promise((resolve, reject) => {
      axios
        .get(path)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  updateOrganizationDetails(_context, payload) {
    let path = '/api/v1/organization/' + payload.id;
    return new Promise((resolve, reject) => {
      axios
        .patch(path, payload.data)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  fetchOrganizationOrders(_context, data) {
    let path = '/api/v1/organization/' + data.id + '/orders';
    return new Promise((resolve, reject) => {
      axios
        .get(path, {
          params: {
            page: data.page,
            limit: data.limit,
            search: data.search,
            sort: data.sort,
            year: data.year,
            month: data.month,
            clinic: data.clinic,
            status: data.status,
          },
        })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchOrganizationInvoices(_context, data) {
    let path = '/api/v1/organization/' + data.organizationId + '/invoices';
    return new Promise((resolve, reject) => {
      axios
        .get(path, {
          params: {
            page: data.page,
            limit: data.limit,
            search: data.search,
            sort: data.sort,
            year: data.year,
            month: data.month,
            clinic: data.clinic,
            status: data.status,
          },
        })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchOrganizationClinicsList(_context, data) {
    let path = '/api/v1/organization/' + data.id + '/clinics';
    return new Promise((resolve, reject) => {
      axios
        .get(path, {
          params: {
            page: data.page,
            limit: data.limit,
            search: data.search,
            sort: data.sort,
            dir: data.dir ? data.dir : 'asc',
            clinicId: data.clinicId,
          },
        })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchOrganizationUsers(_context, data) {
    let path = '/api/v1/organization/' + data.id + '/users';
    return new Promise((resolve, reject) => {
      axios
        .get(path, {
          params: {
            page: data.page,
            limit: data.limit,
            search: data.search,
            clinic: data.clinic,
            userType: data.userType,
            role: data.role,
            sort: data.sort,
          },
        })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchOrganizationUser(_context, data) {
    return axios.get(`/api/v1/organization/${data.orgId}/user/${data.userId}`);
  },
  fetchOrganizationClinics(_context, data) {
    let path = '/api/v1/organization/' + data.id + '/clinics';
    return new Promise((resolve, reject) => {
      axios
        .get(path, {
          params: {
            page: data.page,
            limit: data.limit,
            search: data.search,
            clinic: data.clinic,
            userType: data.userType,
            sort: data.sort,
            model: data.model,
          },
        })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchClinics(_context, type) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/franchises/fetchClinics', { params: type })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchSuperAdminOrganizationClinics(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/organization/superAdminOrganizationClinics/'+data.organizationId)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  createOrganizationBasic(_context, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/v1/organization/create', payload)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  fetchOrganizationTreatments(_context, data) {
    let path = '/api/v1/organization/' + data.id + '/treatments';
    return new Promise((resolve, reject) => {
      axios
        .get(path, { params: data })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchOrganizationDoctorTreatments(_context, data) {
    let path = '/api/v1/organization/' + data.id + '/doctor/treatments';
    return new Promise((resolve, reject) => {
      axios
        .get(path, { params: data })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchAllTreatments(_context, data) {
    let path = '/api/v1/organization/all-treatments';
    return new Promise((resolve, reject) => {
      axios
        .get(path, { params: data })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  assignOrganizationOwner(_context, payload) {
    let path = '/api/v1/organization/' + payload.id + '/assignOwner';
    return new Promise((resolve, reject) => {
      axios
        .post(path, payload.data)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  assignOrganizationStaff(_context, payload) {
    let path =
      '/api/v1/organization/' + payload.orgId + '/assign/' + payload.userId;
    return new Promise((resolve, reject) => {
      axios
        .post(path)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  fetchUsers(_context, data) {
    let path = '/api/v1/organization/' + data.id + '/assignOwner/users';
    return new Promise((resolve, reject) => {
      axios
        .get(path)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchOrganizationAssignList(_context, data) {
    let path = '/api/v1/organization/assign/' + data.id + '/list';
    return new Promise((resolve, reject) => {
      axios
        .get(path)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchOwnerDetails(_context, data) {
    let path = '/api/v1/organization/' + data.id + '/owner';
    return new Promise((resolve, reject) => {
      axios
        .get(path)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  createOrganizationClinic(_context, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/v1/organization/clinic/create', payload)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getAllSupplierList() {
    return new Promise((resolve, reject) => {
      axios
        .get('api/v1/suppliers')
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  getInstantSupplierList() {
    return new Promise((resolve, reject) => {
      jwt
        .fetchHttpAllInstantSupplierList()
        .then(res => {
          return resolve(res.data.data);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  getAllDiscountList() {
    return new Promise((resolve, reject) => {
      axios
        .get('api/v1/discounts')
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  // FROM FRANCHISE ACTIONS
  fetchTreatmentAreas(_context, dataTableParams) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/organization/' + dataTableParams.organizationId + '/treatments/applicableAreas', {
          params: dataTableParams,
        })
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  },
  changeTreatmentAreaStatus(_context, payload) {
    return new Promise((resolve, reject) => {
      axios
        .patch(
          '/api/v1/organization/' + payload.organizationId + '/treatments/applicableAreas/changeStatus',
          payload
        )
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  },
  fetchProductsList(_context, dataTableParams) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/organization/' + dataTableParams.organizationId + '/products/productsList', {
          params: dataTableParams,
        })
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  },
  changeProductStatus(_context, payload) {
    return new Promise((resolve, reject) => {
      axios
        .patch(
          '/api/v1/organization/' + payload.organizationId + '/products/productsList/changeStatus',
          payload
        )
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  },
  fetchOrganizationWithDrugEntries(){
    return new Promise((resolve, reject) => {
      axios
        .get('api/v1/organization/drugbook/fetchOrgWithDrugEntries')
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  },
  fetchOrganizationStaffWithStorePermission(_context, data){
    return new Promise((resolve, reject) => {
      axios
        .get(
          '/api/v1/organization/staff/with-store-permission/'+data.organizationId,
          {
            params: {
              search: data.search,
            },
          }
        )
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  checkOrgClinicsDoctorApproval(_context, orgId) {
    return axios.get(`/api/v1/organization/${orgId}/check-doctor-approval-flow`);
  },
};
